import * as React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import DashboardPage from "./trading/DashboardPage.react";
import FleetPage from "./trading/FleetPage.react";
import TradesPage from "./trading/TradesPage.react";
import ShadowReportPage from "./trading/ShadowReportPage.react";
import MarketPage from "./trading/MarketPage.react";
import LogsPage from "./trading/LogsPage.react";
import DecisionsPage from "./trading/DecisionsPage.react";
import Error404Page from "./trading/Error404Page.react";

import "tabler-react/dist/Tabler.css";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={DashboardPage} />
        <Route exact path="/fleet" component={FleetPage} />
        <Route exact path="/trades" component={TradesPage} />
        <Route exact path="/shadow-report" component={ShadowReportPage} />
        <Route exact path="/market" component={MarketPage} />
        <Route exact path="/decisions" component={DecisionsPage} />
        <Route exact path="/logs" component={LogsPage} />
        <Route component={Error404Page} />
      </Switch>
    </Router>
  );
}

export default App;
